/**
 * Minimum ETS plugin version requirements per feature.
 * These strings must match the format used in EtsApp.Version (e.g. "1.7.1.18").
 */
export const ETS_MIN_VERSION = {
  /** WebSocket-based ETS project PIN (CalcPin connection) */
  ETS_PROJECT_PIN_WEBSOCKET: "1.5.0.0",
  /** Push project to ETS (upload/sync) */
  PUSH_PROJECT_TO_ETS: "1.5.0.0",
  /** Read / readback project from ETS */
  READ_PROJECT_FROM_ETS: "1.7.2.0",
  /** Remote device programming (download to device) */
  PROGRAM_DEVICE: "1.7.2.0",
  /**
   * Local WebSocket server on ws://localhost:1235/ — introduced in plugin v1.7.
   * All local-WS-only features (offline mode, bus info, push events) require this or above.
   */
  LOCAL_WS: "1.7.0.0",
  /**
   * Dedicated getEtsLog socket command that returns ETS undo/history markers
   * directly from a live ETS6 session.
   */
  GET_ETS_LOG: "1.7.0.0",
} as const;

/**
 * Compares two version strings in "A.B.C.D" format.
 * Returns a negative number when v1 < v2, 0 when equal, positive when v1 > v2.
 */
export function compareVersions(v1: string, v2: string): number {
  const parts1 = v1.split(".").map(Number);
  const parts2 = v2.split(".").map(Number);
  const len = Math.max(parts1.length, parts2.length);
  for (let i = 0; i < len; i++) {
    const p1 = parts1[i] ?? 0;
    const p2 = parts2[i] ?? 0;
    if (p1 !== p2) return p1 - p2;
  }
  return 0;
}

/**
 * Returns true when the installed ETS plugin version satisfies the minimum requirement.
 * An empty or missing version string is treated as unknown and does not meet the requirement.
 */
export function isVersionSufficient(currentVersion: string | undefined, requiredVersion: string): boolean {
  if (!currentVersion) return false;
  return compareVersions(currentVersion, requiredVersion) >= 0;
}
